import * as dotenv from 'dotenv';

dotenv.config();

export default {
    BASE_URL: process.env.BASE_URL || 'https://vend.link',
    API_URL: process.env.API_URL || 'https://api.vend.link/api/site',
};
